<template>
    <div>
        <div class="text-center">
            <!--<div class="col-lg-3 col-12 d-inline-block">-->
            <!--<div class="input-group">-->
            <!--<div class="input-group-prepend">-->
            <!--<span class="input-group-text">مشتری :</span>-->
            <!--</div>-->
            <!--<vs-select :data="customers" :mode="'create'"-->
            <!--:header="{multiple: false, label: 'title'}"-->
            <!--@onChange="onChange"></vs-select>-->
            <!--</div>-->
            <!--</div>-->
            <div>
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1; transform">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <!--<div class="d-inline-block mx-3">-->
                <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
                <!--</div>-->
            </div>
        </div>
        <hr/>
        <div class="row" v-if="listView">
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in transactions">
                <div class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <!--<div class="col-md-3">-->
                        <!--<strong>{{item.factor}}</strong>-->
                        <!--</div>-->
                        <div class="col-md-3">
                            <strong>حساب: </strong>
                            <span>{{item.account}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>مبلغ: </strong>
                            <span>{{item.creditor.toLocaleString()}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>تاریخ: </strong>
                            <span>{{item.persianDate}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>وضعیت: </strong>
                            <span>{{item.checkStatusfa}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in transactions">
                <div class="card transaction mt-2 mb-2" @click="onCardClicked($event, index)">
                    <div class="card-header">
                        <h4 class="text-center">{{item.factor}}</h4>
                    </div>
                    <div class="card-body">
                        <span><b>حساب: </b></span>
                        <span>{{item.account}}</span>
                        <br>
                        <span><b>توضیحات: </b></span>
                        <span>{{item.description}}</span>
                        <br>
                        <span><b>تاریخ: </b></span>
                        <span>{{item.persianDate}}</span>
                        <br>
                        <div class="text-center text-danger">
                            <h5 class="d-inline">مبلغ: </h5>
                            <h5 class="d-inline">{{item.creditor.toLocaleString()}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="transactions === undefined" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="transactions !== undefined && transactions.length < dataCount" class="col-lg-12 text-center mb-3"
                 @click="getTransactions">
                <button class="btn btn-success">نمایش تراکنش های بیشتر</button>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>

            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true" v-if="showModal ">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">مشخصات چک صادره</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" id="printMe">
                            <div class="row">
                                <div class="col-lg-9 my-2">
                                    <label class="">چک : </label>
                                    <span class="mx-3 input-group-text d-inline-block">{{checkData.outSourceName}}</span>
                                </div>
                                <div class="col-lg-3 my-2">
                                    <label class="">مبلغ : </label>
                                    <span class="mx-3 input-group-text d-inline-block">{{checkData.price.toLocaleString()}}</span>
                                </div>
                                <div class="col-lg-5 mb-2">
                                    <label class="">چک در وجه : </label>
                                    <span class="mx-2 input-group-text d-inline-block">{{checkData.receiver}}</span>
                                </div>
                                <div class="col-lg-3 p-1 mb-2">
                                    <label class="">تاریخ چک : </label>
                                    <span class="mx-1 input-group-text d-inline-block">{{checkData.checkDate}}</span>
                                </div>
                                <div class="col-lg-3 p-1 mb-2">
                                    <label class="">شماره چک : </label>
                                    <span class="mx-1 input-group-text d-inline-block">{{checkData.checkNumber}}</span>
                                </div>
                                <hr/>

                                <!--<div class="col-lg-6 my-2">-->
                                <!--<label class="">نام بانک : </label>-->
                                <!--<span class="mx-3 input-group-text d-inline-block">{{checkData.branchName}}</span>-->
                                <!--</div>-->
                                <div class="col-lg-6 mb-2">
                                    <label class="">وضعیت چک : </label>
                                    <span class="mx-3 input-group-text d-inline-block">{{checkData.status}}</span>
                                </div>
                                <div class="col-lg-12 my-2" v-if="showChangeStatus">
                                    <label class="">تغییر وضعیت : </label>
                                    <vs-select class="col-lg-8 d-inline-block" :data="statuses"
                                               :header="{multiple: false, label: 'name'}" :mode="'create'"
                                               @onChange="onStatusChange"></vs-select>
                                </div>
                                <div class="col-lg-12 my-2" v-if="showPass">
                                    <label class="">چک از حساب : </label>
                                    <vs-select class="col-lg-8 d-inline-block" :data="banks"
                                               :header="{multiple: false, label: 'outSourceName'}" :mode="'create'"
                                               @onChange="onSourceSelect"></vs-select>
                                    <label class=""> پاس میشود </label>
                                </div>
                                <div class="col-lg-12 text-center" v-if="showPass">
                                    <button type="button" class="btn btn-success mr-1" @click="onCheckPass">تائید و
                                        پاس
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                    class="fa fa-print"></i></button>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'payment-check-archive',
        components: {
            VsSelect,
            DatePicker,
        },
        data() {
            return {
                transactions: [],
                queryParams: {
                    pageSize: 9,
                    pageIndex: 0,
                    type: 1,
                    outsourceType: 13
                },
                dataCount: 0,

                listView: false,
                checkData: {
                    price: 0,
                },
                showModal: false,
                statuses: [],
                newStatus: 0,
                checkId: 0,
                banks: [],
                cashDesks: [],
                showPass: false,
                checkCode: "",
                sourceCode: "",
                showChangeStatus: false,
                isSending: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",


            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);

            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.showModal = false;
            // console.log("salam")
            new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                this.transactions = response.data.data;
                this.dataCount = response.data.count;
                if (this.transactions !== undefined) {
                    for (let item of this.transactions) {
                        let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                        Vue.set(item, "persianDate", date);
                        switch (item.checkStatus) {
                            case 0:
                                item.checkStatusfa = "در انتظار";

                                break;
                            case 1:

                                item.checkStatusfa = "پاس شده";
                                break;
                            case 2:

                                item.checkStatusfa = "واگذار شده";
                                break;
                            case 3:

                                item.checkStatusfa = "برگشت شده";
                                break;

                        }
                    }
                }
                $("#loading").hide();
            }).catch(error => {
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            this.queryParams.types = 1;
            this.queryParams.pageSize = 50;
            new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                this.cashDesks = response.data.data;
                this.queryParams.types = 2;
                this.queryParams.pageSize = 50;
                new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                    let arr = response.data.data;
                    for (let i = 0; i < this.cashDesks.length; i++) {
                        this.banks.push(this.cashDesks[i]);
                    }
                    for (let i = 0; i < arr.length; i++) {
                        this.banks.push(arr[i]);
                    }


                    // console.log(this.banks);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });


            this.queryParams.pageSize = 9;
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            getTransactions() {
                this.queryParams.pageIndex++;
                this.queryParams.pageSize = 50;
                this.queryParams.type = 1;
                $("#loading").show();
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions.push.apply(this.transactions, response.data.data);
                    for (let item of this.transactions) {
                        let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                        Vue.set(item, "persianDate", date);
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                this.checkId = this.transactions[index].outSourceId;
                this.showModal = true;
                // $("#voucherData").modal("show");
                new BaseService('OutSource', `/${this.checkId}`).getList().then(response => {
                    this.checkData = response.data;
                    this.checkCode = this.checkData.code;
                    this.checkData.checkDate = Moment(this.checkData.checkDate.slice(0, 10), 'YYYY-MM-DD').format("jYYYY/jMM/jDD");
                    switch (this.checkData.checkStatus) {
                        case 0:
                            this.checkData.status = "در انتظار";
                            this.showChangeStatus = true;
                            this.statuses = [
                                {
                                    status: 1,
                                    name: 'پاس کردن چک'
                                },
                                // {
                                //     status: 3,
                                //     name: 'برگشت زدن چک'
                                // }
                            ];
                            break;
                        case 1:
                            this.statuses = [];
                            this.showChangeStatus = false;
                            this.checkData.status = "پاس شده";
                            break;
                        case 2:
                            this.statuses = [];
                            this.showChangeStatus = false;
                            this.checkData.status = "واگذار شده";
                            break;
                        case 3:
                            this.statuses = [];
                            this.showChangeStatus = false;
                            this.checkData.status = "برگشت شده";
                            break;

                    }
                    this.showModal = true;
                    $("#voucherData").modal("show");
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })
            },
            onStatusChange(e) {
                this.newStatus = e.status;
                if (this.newStatus === 1) {
                    this.showPass = true;
                }
            },
            onSourceSelect(e) {
                this.sourceCode = e.code;
            },
            onCheckPass() {
                if (!this.isSending) {
                    this.isSending = true;
                    let model = {
                        code: this.sourceCode,
                        price: this.checkData.price,
                        check: null,
                        fromCode: "",
                        toCode: this.checkData.code
                    };
                    new BaseService('payment').create(model).then(response => {
                        // console.log(response.data);
                        this.$noty.success(response.data.message);
                        this.sourceCode = "";
                        this.showPass = false;
                        this.newStatus = [];
                        this.showChangeStatus = false;
                        $("#voucherData").modal("hide");
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                    // public virtual string Code { get; set; }
                    // public decimal Price { get; set; }
                    // public CheckDto Check { get; set; }
                    // public string FromCode { get; set; }
                    // public string ToCode { get; set; }
                    // public override string Code { get; set; }
                }
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                this.queryParams = {
                    fromdate: this.fromDate,
                    toDate: this.toDate,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1,
                    outsourceType: 13

                };
                new BaseService('reports', '/gettransactionreport').getList(this.queryParams).then(response => {
                    this.transactions = response.data.data;
                    this.dataCount = response.data.count;
                    if (this.transactions !== undefined) {
                        for (let item of this.transactions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>